import {trackProductInteraction} from '@aboutyou/legacy-tracking-sdk';
import {useTracking} from '../utils/utils';

import {Brand} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/brand.types';
import {Product} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/product.types';
import {MarkOptional} from 'ts-essentials';
import {RecoListTrackingData} from '../trackerComponents/TrackPromotions';
import {trackingProductGetter} from '../utils/trackingProductGetter';

export const useTrackProductClick = (options?: {
  trackPreviousPage?: boolean;
}) => {
  const {TrackingClient, pageContextCallback} = useTracking();
  const trackPreviousPage = options?.trackPreviousPage ?? false;
  return (
    productTile: {product: Product; brand: Brand},
    streamPosition: number,
    trackingData?: MarkOptional<RecoListTrackingData, 'sectionIndex'> & {
      sortingChannel?: string;
    },
  ) => {
    TrackingClient.track(
      trackProductInteraction({
        type: 'click',
        trackPreviousPage,
        ...trackingProductGetter({
          product: productTile.product!,
          brand: productTile.brand!,
          streamPosition,
          sortChannel: trackingData?.sortingChannel,
          pageType: pageContextCallback().type,
          recoType: trackingData?.recoType,
          headline: trackingData?.headline,
          elements: trackingData?.elements,
          sectionIndex: trackingData?.sectionIndex,
        }),
      }),
    );
  };
};
